import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

const MAX_LENGTH = 255;

registerComponent(
  "product-note",
  class ProductNote extends WYATTElement {
    constructor() {
      super();
      this.clearOnCollapse = this.config.clearOnCollapse ?? true;
      this.expandButton = this.querySelector("[data-expand]");
      this.collapseButton = this.querySelector("[data-collapse]");
      this.textarea = this.querySelector("[data-textarea]");
      this.counter = this.querySelector("[data-counter]");

      this.expandButton.addEventListener("click", this.expand.bind(this));
      this.collapseButton.addEventListener("click", this.collapse.bind(this));
      this.textarea.addEventListener("input", this.handleInput.bind(this));
    }

    expand() {
      this.setAttribute("data-expanded", "true");
      this.textarea.disabled = false;
      this.textarea.focus();
      this.updateCounter();
    }

    collapse() {
      if (this.clearOnCollapse) {
        this.textarea.value = "";
      }
      this.textarea.disabled = true;
      this.setAttribute("data-expanded", "false");
      this.updateCounter();
      this.expandButton.focus();
    }

    handleInput() {
      this.updateCounter();
    }

    updateCounter() {
      this.counter.textContent = `${this.textarea.value.length}/${MAX_LENGTH}`;
    }
  },
);
